import React, { useEffect, useState, useContext } from 'react';
import '../../products.css';
import FavouriteItem from '../favouritesItem/FavouriteItem';
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import UserContext from '../../../../../context/UserContext';
import { toggleSelectedProduct } from '../../../../../context/UserContext';
import ProductsItem from '../../productItem/ProductsItem';

export default function FavouriteList({ apiEndpoint }) {
  const [productCheckedState, setProductCheckedState] = useState({});
  const { selectedProducts, setSelectedProducts, newlySelectedProducts } = useContext(UserContext);
  const [tooltipVisible, setTooltipVisible] = useState({
    popUp: false,
    id: null
  });
  const navigate = useNavigate();

  const handleMouseEnter = (id) => {
    setTooltipVisible({
      ...tooltipVisible,
      popUp: true,
      id: id


    })
  };

  const handleMouseLeave = () => {
    setTooltipVisible({
      ...tooltipVisible,
      popUp: false,
      id: null


    })
  };

  // Add Products in Compare Section
  const handleCheckboxChange = (productId) => {
    toggleSelectedProduct(productId, selectedProducts, setSelectedProducts);
  };

  // Remove a Single Product from Compare Section
  const handleRemoveProduct = (productId) => {
    setSelectedProducts((prevSelectedProducts) =>
      prevSelectedProducts.filter((product) => product.id !== productId)
    );

    setProductCheckedState((prevState) => {
      const updatedState = { ...prevState };
      delete updatedState[productId];
      return updatedState;
    });
  };

  // Remove all Products from Compare Section
  const handleClearAll = () => {
    setSelectedProducts([]);
  }
  const handleClick = (id) => {
   
    setTooltipVisible({
          ...tooltipVisible,
          popUp: true,
          id: id
    
    
        })
};

  return (
    <>

    <div className='deals p-0'>
        <div className="row products-list w-100">
          {newlySelectedProducts?.map((data) => (
            <ProductsItem
              key={data?._id}
              chipset={data?.chipset}
              id={data?._id}
              slug={data?.slug}
              thumbnail={data?.image}
              title={data?.title}
              series={data?.series}
              brand={data?.brand}
              price={
                data.type == 1
                  ? data.new_retail_website_price
                  : data?.lowest_ask > 0
                    ? data?.lowest_ask
                    : "TBD"
              }
              model={data?.model}
              data={data}
              condition={data?.type}
              // layout={activeLayout}
              // isChecked={productCheckedState[data?._id]}
              onCheckboxChange={handleCheckboxChange}
            />
          ))}
        </div>
    </div>
    </>
  );
}
